<template>
  <div class="text-center">
    <!-- Commented by TH-7921
      <router-link v-if="account.isProfile" :to="{ query: { ...$route.query, modal: 'ChangePassword' } }">
        <btn
          :label="$t('_web_profile-edit_change-password', 'Change Password')"
        />
      </router-link> -->
    <Btn
      v-if="!noCancel"
      class="btn-default mx-2 h-mr-4 align-self-center"
      :class="{ 'is-loading': isLoading }"
      :label="$t('_web_profile-cancel_update', 'Cancel')"
      @click="cancel"
    />
    <Btn
      class="btn-primary mx-2 align-self-center"
      :class="{ 'is-loading': isLoading }"
      :label="$t('_web_profile-edit_update', 'Update')"
      @click="saveAccount"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Btn from '@/components/atoms/HeraFormBtn';

export default {
  name: 'AccountStatusBarActionsEdit',
  inject: ['$validator'],
  components: {
    Btn,
  },
  props: {
    noCancel: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId', 'accountType']),
    ...mapGetters(['accountChangedData']),
  },
  methods: {
    ...mapActions(['errorNotify', 'saveAccountChanges']),
    cancel() {
      this.$router.push({
        name: this.$routerNames.ACCOUNT,
        params: {
          ...this.account.params,
          ...this.$route.params,
        },
        hash: '#saved',
      });
    },
    saveAccount() {
      if (this.$lodash.isEmpty(this.accountChangedData)) {
        return this.$router.push({
          name: this.$routerNames.ACCOUNT,
          params: {
            ...this.account.params,
            ...this.$route.params,
          },
          hash: '#saved',
        });
      }
      if (!this.errors.count()) {
        this.isLoading = true;
        this.$validator
          .validateAll()
          .then(res =>
            res
              ? Promise.resolve(res)
              : Promise.reject(
                  this.$t(
                    '_web_form-validation-error',
                    'Form validation failed'
                  )
                )
          )
          .then(this.saveAccountChanges)
          .then(() => {
            this.isLoading = false;
            this.$router.push({
              name: this.$routerNames.ACCOUNT,
              params: {
                ...this.$route.params,
                ...this.account.params,
              },
              hash: '#saved',
            });
          })
          .catch(err => {
            this.isLoading = false;
            this.errorNotify(err);
          }).finally;
      }
    },
  },
};
</script>
